<template>
  <div class="ma-3 text-xs-center">
    <h3 style="font-size: 20pt">{{artist.name}}</h3>
      <img
        class="artistImage"
        v-if="artist.image" v-bind:src="artist.image"
      />
    <h1 class="mt-3 mb-3">Sheet Music</h1>
    <v-container class="pa-0 justify-center">
      <v-layout column wrap>
        <div style="flex-wrap: wrap; align-items: center; justify-content: center; display: flex; width: 100%;">
          <div v-for="book in artist.books" v-bind:key="book">
            <MusicSelectionItem style="" :book="book"></MusicSelectionItem>
          </div>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>


<script>
import MusicSelectionItem from "./MusicSelectionItem.vue";

export default {
  name: "ArtistDetails",
  methods: {
  },
  props: {
    artist: Object,
  },
  components: {
    MusicSelectionItem,
  },
  data: () => ({}),
};
</script>

<style scoped>
.artistImage {
  max-width: 200px;
}
</style>
